<template>
  <artisio-modal size="md" :visible="modal.show" :title="$t(`DPV Description`)" @hidden="hideDescriptionModal"
      :hide-footer="true" scrollable>
    {{ modal.description }}
  </artisio-modal>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";

  const {mapState, mapActions} = createNamespacedHelpers('dpv/dpv');
  export default {
    name: "DpvDescriptionModal",
    components: {ArtisioModal},
    computed: {
      ...mapState({
        modal: state => state.descriptionModal,
      })
    },
    methods: {
      ...mapActions(['hideDescriptionModal']),
    }
  }
</script>

<style lang="scss" scoped>
</style>
